import { Box, Button, Grid, Skeleton, Stack, Switch, Typography } from "@mui/material";
import React from "react";
import TabComp from "src/components/shared/TabComp";
import useAppGlobal from "src/context/useAppGlobal";
import useTPList from "src/hooks/setting/transportation-provider/useTPList";
import TPCreateDialog from "./TPCreateDialog";
import NamePage from "src/components/shared/NamePage";
import useQueryParams from "src/hooks/useQueryParams";
import { SETTING_SYSTEM_TRANSLATE, SETTING_SYSTEM_TYPE } from "src/constant";
import { Add } from "@mui/icons-material";
const label = { inputProps: { "aria-label": "Switch demo" } };

export default function TransportationProviderTable() {
  const [option] = useQueryParams();
  const { handleOpenDialog } = useAppGlobal();
  const { data, isLoading } = useTPList({
    type: SETTING_SYSTEM_TYPE[option?.tab],
  });

  const addTP = () => {
    handleOpenDialog({
      title: "Tạo đơn vị vận chuyển",
      content: <TPCreateDialog />,
      size: "md",
    });
  };

  const handleUpdateTP = async (item) => {
    handleOpenDialog({
      title: "Cập nhật đơn vị vận chuyển",
      content: <TPCreateDialog item={item} />,
      size: "md",
    });
  };

  return (
    <Grid container>
      <NamePage
        name={"Thiết lập hệ thống"}
        subName={SETTING_SYSTEM_TRANSLATE[option?.tab]}
      />
      <Stack
        gap={1.5}
        my={1.5}
      >
        <Button
          startIcon={<Add />}
          variant="contained"
          onClick={addTP}
        >
          Thêm ĐVVC
        </Button>
        <Box width="100%">
          <TabComp
            tabs={[
              { id: "transportation-provider", name: "Tất cả ĐVVC" },
              { id: "transportation-provider-internal", name: "ĐVVC nội bộ" },
            ]}
          />
        </Box>
      </Stack>

      <Grid container>
        {!isLoading ? (
          <>
            {Array.isArray(data?.data) ? (
              data?.data?.map((v) => {
                return (
                  <Grid
                    key={v?._id}
                    item
                    md={6}
                    xs={12}
                  >
                    <Box
                      sx={{
                        border: "1px solid var(--light-grey)",
                        m: "6px",
                        p: "12px",
                        borderRadius: "6px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box
                        display="flex"
                        justifyContent="flex-start"
                        alignItems="center"
                        gap="12px"
                      >
                        <Typography
                          sx={{ cursor: "pointer" }}
                          onClick={() => handleUpdateTP(v)}
                        >
                          {v?.name ?? "-"}
                        </Typography>
                        <Switch
                          onChange={() => alert("Tính năng đang phát triển...")}
                          {...label}
                        />
                      </Box>
                      <Box>
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => alert("Tính năng đang phát triển...")}
                        >
                          Thiết lập
                        </Button>
                      </Box>
                    </Box>
                  </Grid>
                );
              })
            ) : (
              <>Chưa có đơn vị vận chuyển được tạo</>
            )}
          </>
        ) : (
          <Skeleton
            width="100%"
            height="56px"
          />
        )}
      </Grid>
    </Grid>
  );
}
